module.exports = __webpack_public_path__ + "01_mid_black.06ec104a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_mid_black.png
// module id = mlod
// module chunks = 0